import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropzone", "previews", "fileInput"]

  declare dropzoneTarget: HTMLElement;
  declare previewsTarget: HTMLElement;
  declare fileInputTarget: HTMLInputElement;

  files: File[] = [];
  maxFilesValue: number = 10;

  connect() {
    const maxAttr = this.fileInputTarget.dataset.attachmentMaxFilesValue
    this.maxFilesValue = parseInt(maxAttr || "10")

    this.dropzoneTarget.addEventListener("dragover", (e) => {
      e.preventDefault()
      this.dropzoneTarget.classList.add("dragover")
    })

    this.dropzoneTarget.addEventListener("drop", (e) => {
      e.preventDefault()
      this.dropzoneTarget.classList.remove("dragover")
      if (e.dataTransfer) {
        const newFiles = Array.from(e.dataTransfer.files)
        this.handleFiles(newFiles)
      }
    })
  }

  preview(event: Event) {
    const input = event.target as HTMLInputElement;
    const newFiles = input.files ? Array.from(input.files) : [];
    this.handleFiles(newFiles)
  }

  handleFiles(newFiles: File[]) {
    // accept all  files
    if ((this.files.length + newFiles.length) > this.maxFilesValue) {
      alert(`最大で${this.maxFilesValue}件のファイルまでアップロードできます。`)
      return
    }

    // const uniqueFiles = newFiles.filter(newFile => {
    //   return !this.files.some(existingFile =>
    //     existingFile.name === newFile.name &&
    //     existingFile.size === newFile.size &&
    //     existingFile.lastModified === newFile.lastModified
    //   )
    // })

    // if (uniqueFiles.length === 0) {
    //   alert("Tất cả các file đã chọn đều đã được thêm trước đó.")
    //   return
    // }

    this.files = this.files.concat(newFiles)
    this.updatePreview()

    // Update fileInput field with DataTransfer
    const dataTransfer = new DataTransfer()
    this.files.forEach(file => dataTransfer.items.add(file))
    this.fileInputTarget.files = dataTransfer.files
  }

  updatePreview() {
    this.previewsTarget.innerHTML = ""

    this.files.forEach((file, index) => {
      const container = document.createElement("div")
      container.classList.add("preview-file")
      container.dataset.index = index.toString()

      // Tạo nút xóa
      const removeBtn = document.createElement("button")
      removeBtn.type = "button"
      removeBtn.classList.add("remove-button")
      removeBtn.textContent = "✖️"
      removeBtn.addEventListener("click", () => this.removeFile(index))
      container.appendChild(removeBtn)

      // Add thumbnail if is an image
      if (file.type.startsWith("image/")) {
        const reader = new FileReader()
        reader.onload = (e) => {
          const img = document.createElement("img")
          if (typeof e.target?.result === "string") {
            img.src = e.target.result
          }
          img.classList.add("preview-image")
          container.appendChild(img)
          this.previewTextContent(file, container)
        }
        reader.readAsDataURL(file)
      } else {
        const icon = document.createElement("div")
        icon.classList.add("file-icon")
        icon.innerHTML = this.getFileIcon(file)
        container.appendChild(icon)

        this.previewTextContent(file, container)
      }
      this.preventDragging(container) // Prevent dragging of displayed files
      this.previewsTarget.appendChild(container)
    })
  }

  preventDragging(container: HTMLElement) {
    container.addEventListener("dragstart", (e) => {
      e.preventDefault();
    });
  }

  previewTextContent(file: File, wrapper: HTMLElement) {
    const name = document.createElement("p")
    const maxLength = 20;
    const displayName =
      file.name.length > maxLength
        ? file.name.slice(0, maxLength) + "..."
        : file.name;

    name.textContent = `${displayName} (${Math.round(file.size / 1024)} KB)`;
    wrapper.appendChild(name)
  }

  removeFile(index: number) {
    this.files.splice(index, 1) // Remove file from the array
    this.updatePreview()

    // Update fileInput field with DataTransfer
    const dataTransfer = new DataTransfer()
    this.files.forEach(file => dataTransfer.items.add(file))
    this.fileInputTarget.files = dataTransfer.files
  }

  getFileIcon(file: File) {
    const type = file.type
    const name = file.name.toLowerCase()

    if (type.includes("pdf") || name.endsWith(".pdf")) return "📄"  // PDF
    if (type.includes("zip") || name.endsWith(".zip") || name.endsWith(".rar")) return "🗜️"  // Compressed
    if (type.includes("word") || name.endsWith(".doc") || name.endsWith(".docx")) return "📝"  // Word
    if (type.includes("excel") || name.endsWith(".xls") || name.endsWith(".xlsx")) return "📊"  // Excel
    if (type.includes("csv") || name.endsWith(".csv")) return "📑"  // CSV
    if (type.includes("json") || name.endsWith(".json")) return "🧾"  // JSON
    if (type.startsWith("text/") || name.endsWith(".txt")) return "📄"  // Plain text
    return "📁"  // Default icon for unknown files
  }
}
